<template>
    <NuxtLayout>
        <ClientOnly>
            <NotificationContainer />
        </ClientOnly>
        <NuxtPage />
    </NuxtLayout>
</template>

<script setup lang="ts">
useHead({
    titleTemplate: "%s | Moebix",
});
</script>
